import React from 'react';
import {useIntl} from 'react-intl';
import {FileList} from './FileList';
import Empty from '../../../_common/components/Empty';
import PopupUploadFiles from '../../../_common/components/PopupUploadFiles';
import {DropdownButton} from './DropdownButton';
import PopupSelectOrderFile from './PopupSelectOrderFile';
import {useOldInspectionDocumentsContext} from '../OldInspectionsDocumentsContext';
import {useOldInspectionDetailsContext} from '../OldInspectionsDetailsContext';
import {uploadFileTypes} from '../../../_common/constants/uploadFileTypes';

const TabDocuments = () => {
  const {formatMessage} = useIntl();
  const {fileList, uploadFiles} = useOldInspectionDocumentsContext();
  const {orderID, shumaID} = useOldInspectionDetailsContext() as {orderID: number, shumaID: number};

  const getItemPopupOrderFiles = (item: {fileTypeID: number}) => (
    <PopupSelectOrderFile
      label={item.fileTypeID.toString()}
      orderID={orderID}
      shumaID={shumaID}
      fileTypeID={item.fileTypeID}
    />
  );

  return (
    <>
      <div className={'mb-6 d-flex align-items-center justify-content-center'}>
        <PopupUploadFiles onUploadFile={uploadFiles} />
        <DropdownButton
          icon={'../../../media/common/Check_white.svg'}
          buttonLabel={formatMessage({id: 'choose-file-from-order', defaultMessage: 'Choose file from order'})}
          items={uploadFileTypes.map(getItemPopupOrderFiles)}
          disabled={shumaID.toString() === '-1' || Boolean(!orderID)}
        />
      </div>
      <div>
        {(fileList.length > 0)
          ? <FileList/>
          : <Empty message={formatMessage({id: 'no-files',defaultMessage: 'No files'})} customContainerClassname={'pt-16'}/>
        }
      </div>
    </>
  );
};

export default TabDocuments;
